import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Plus, Trash2, Edit2, ChevronDown, ChevronUp } from "lucide-react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiUrl from "../Environment/ApiUrl";

const Purchase_update = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [categoryTableData, setCategoryTableData] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState({});
  const [quantities, setQuantities] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const BASE_URL = "http://localhost/manuel_tyre";

  const [purchaseData, setPurchaseData] = useState({
    purchaseId: "",
    purchaseDate: new Date().toISOString().split("T")[0],
    mobile_no: "",
    dealerName: "",
    subTotal: 0,
    gstAmount: 0,
    netTotal: 0,
    paidAmount: 0,
    balance: 0,

  });

  const [purchaseItems, setPurchaseItems] = useState([]);
  const [showAddRow, setShowAddRow] = useState(true);
  const [editIndex, setEditIndex] = useState(null);
  const [purchaseItemForm, setPurchaseItemForm] = useState({
    HSN_code: "",
    branch_name: "Default Branch",
    brand_name: "",
    type: "",
    tyre_size: "",
    Quantity: "",
    purchase_rate: "",
    Gst: "",
    Category: "",
    Subcategory: "",
    status: "In Stock",
    purchase_quantity: "",
    purchase_gst: "",
    Mrp: "",
  });

  const [formErrors, setFormErrors] = useState({
    brand_name: "",
    Quantity: "",
    purchase_rate: "",
    Gst: "",
    purchaseDate: "",
    purchase_quantity: "",
    purchase_gst: "",
    Mrp: "",
    dealerName: "",
    mobile_no: "",
  });

  const [paymentHistory, setPaymentHistory] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentForm, setPaymentForm] = useState({
    date: new Date().toISOString().split("T")[0],
    pay_type: "",
    amount: "",
  });
  const [paymentEditIndex, setPaymentEditIndex] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [productData, setProductData] = useState({
    HSN_code: "",
    Category: "",
    Subcategory: "",
    branch_name: "Default Branch",
    brand_name: "",
    type: "",
    tyre_size: "",
    rate: "",
    gst: "",
    status: "Active",
    Mrp: "",
  });

  const validatePurchaseItemForm = () => {
    const errors = {};
    if (!purchaseItemForm.brand_name) errors.brand_name = "Brand is required";
    if (!purchaseItemForm.Quantity) errors.Quantity = "Quantity is required";
    else if (isNaN(purchaseItemForm.Quantity) || Number(purchaseItemForm.Quantity) <= 0)
      errors.Quantity = "Quantity must be a positive number";
    if (!purchaseItemForm.purchase_rate) errors.purchase_rate = "Purchase Rate is required";
    else if (isNaN(purchaseItemForm.purchase_rate) || Number(purchaseItemForm.purchase_rate) <= 0)
      errors.purchase_rate = "Purchase Rate must be a positive number";
    if (!purchaseItemForm.Gst) errors.Gst = "GST is required";
    else if (isNaN(purchaseItemForm.Gst) || Number(purchaseItemForm.Gst) < 0)
      errors.Gst = "GST must be a non-negative number";
    if (!purchaseItemForm.purchase_quantity) errors.purchase_quantity = "Purchase Quantity is required";
    else if (isNaN(purchaseItemForm.purchase_quantity) || Number(purchaseItemForm.purchase_quantity) <= 0)
      errors.purchase_quantity = "Purchase Quantity must be a positive number";
    if (!purchaseItemForm.purchase_gst) errors.purchase_gst = "Purchase GST is required";
    else if (isNaN(purchaseItemForm.purchase_gst) || Number(purchaseItemForm.purchase_gst) < 0)
      errors.purchase_gst = "Purchase GST must be a non-negative number";
    if (!purchaseItemForm.Mrp) errors.Mrp = "MRP is required";
    else if (isNaN(purchaseItemForm.Mrp) || Number(purchaseItemForm.Mrp) <= 0)
      errors.Mrp = "MRP must be a positive number";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const calculateTotals = useCallback((items, payments) => {
    const subTotal = items.reduce((sum, item) => {
      const quantity = Number(item.purchase_quantity) || 0;
      const rate = Number(item.purchase_rate) || 0;
      return sum + quantity * rate;
    }, 0);

    const gstAmount = items.reduce((sum, item) => {
      const quantity = Number(item.purchase_quantity) || 0;
      const rate = Number(item.purchase_rate) || 0;
      const gst = Number(item.purchase_gst) || 0;
      return sum + (quantity * rate * gst) / 100;
    }, 0);

    const netTotal = subTotal + gstAmount;
    const paidAmount = payments.reduce(
      (sum, payment) => sum + (Number(payment.amount) || 0),
      0
    );
    const balance = netTotal - paidAmount;
    const paymentStatus =
      paidAmount >= netTotal ? "PAID" : paidAmount > 0 ? "PARTIAL" : "UNPAID";

    setPurchaseData((prev) => ({
      ...prev,
      subTotal: subTotal.toFixed(2),
      gstAmount: gstAmount.toFixed(2),
      netTotal: netTotal.toFixed(2),
      paidAmount: paidAmount.toFixed(2),
      balance: balance.toFixed(2),
      paymentStatus,
    }));
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        // Fetch products
        const productResponse = await axios.get(`${ApiUrl}/product_data.php`);
        let fetchedProducts = Array.isArray(productResponse.data.data)
          ? productResponse.data.data
          : [];
        const requestedProduct = {
          id: `custom_${Date.now()}`,
          HSN_code: "PRO-002",
          Category: "LT",
          Subcategory: "Pick up Radils",
          branch_name: "Default Branch",
          brand_name: "MRF",
          type: "Tubeless",
          tyre_size: "100/90-17",
          status: "Inactive",
          rate: "1000",
          gst: "18",
          Mrp: "1200",
        };
        if (
          !fetchedProducts.some(
            (item) =>
              item.tyre_size === requestedProduct.tyre_size &&
              item.brand_name === requestedProduct.brand_name
          )
        ) {
          fetchedProducts = [...fetchedProducts, requestedProduct];
        }
        setProducts(fetchedProducts);

        const categoriesMap = {};
        fetchedProducts.forEach((item) => {
          if (item.Category) {
            if (!categoriesMap[item.Category])
              categoriesMap[item.Category] = new Set();
            if (item.Subcategory)
              item.Subcategory.split(",")
                .map((subCat) => subCat.trim())
                .forEach((subCat) => categoriesMap[item.Category].add(subCat));
          }
        });
        setCategoryTableData(
          Object.keys(categoriesMap).map((category) => ({
            Category: category,
            SubCategories: Array.from(categoriesMap[category]),
          }))
        );

        setQuantities(
          fetchedProducts.reduce((acc, item) => ({ ...acc, [item.id]: 0 }), {})
        );

        // Fetch purchase data by ID
        if (id) {
          const purchaseResponse = await axios.get(
            `${ApiUrl}/purchase_data.php/${id}`
          );
          if (purchaseResponse.data && purchaseResponse.data.data) {
            const purchase = purchaseResponse.data.data;
            setPurchaseData({
              purchaseId: purchase.purchaseId || "",
              purchaseDate: purchase.purchaseDate
                ? new Date(purchase.purchaseDate).toISOString().split("T")[0]
                : new Date().toISOString().split("T")[0],
              mobile_no: purchase.mobile_no || "",
              dealerName: purchase.dealerName || "",
              subTotal: parseFloat(purchase.subTotal || 0).toFixed(2),
              gstAmount: parseFloat(purchase.gstAmount || 0).toFixed(2),
              netTotal: parseFloat(purchase.netTotal || 0).toFixed(2),
              paidAmount: parseFloat(purchase.paidAmount || 0).toFixed(2),
              balance: parseFloat(purchase.netTotal - purchase.paidAmount || 0).toFixed(2),
            });
            setPurchaseItems(
              purchase.purchaseItems.map((item) => ({
                ...item,
                purchase_rate: item.purchase_rate || item.Rate,
                purchase_quantity: item.purchase_quantity || item.Quantity,
                purchase_gst: item.purchase_gst || item.Gst,
                Mrp: item.Mrp || "",
              })) || []
            );
            setPaymentHistory(purchase.purchasePaymentHistory || []);

            setQuantities((prev) => ({
              ...prev,
              ...purchase.purchaseItems.reduce(
                (acc, item) => ({
                  ...acc,
                  [item.id]: item.purchase_quantity || item.Quantity || 0,
                }),
                {}
              ),
            }));
          } else {
            setError("No purchase data found");
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(
          error.response?.status === 404
            ? "Purchase not found"
            : "Failed to fetch data: " + error.message
        );
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const fetchNextProductId = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${ApiUrl}/product_data.php/generate-product-code`
      );
      if (!response.data?.HSN_code)
        throw new Error("Invalid HSN code response");
      setProductData((prev) => ({ ...prev, HSN_code: response.data.HSN_code }));
    } catch (error) {
      console.error("Error fetching product ID:", error);
      setError(error.response?.data?.message || "Failed to fetch product ID");
    } finally {
      setIsLoading(false);
    }
  };

  const toggleCategory = (category) => {
    setExpandedCategories((prev) => ({ ...prev, [category]: !prev[category] }));
  };

  const handleQuantityChange = useCallback(
    (item, action) => {
      setQuantities((prev) => {
        const newQuantities = { ...prev };
        const currentQuantity = newQuantities[item.id] || 0;
        const newQuantity =
          action === "increase"
            ? currentQuantity + 1
            : Math.max(0, currentQuantity - 1);

        newQuantities[item.id] = newQuantity;

        setPurchaseItems((prevItems) => {
          const existingItemIndex = prevItems.findIndex(
            (pi) => pi.id === item.id
          );
          const newItem = {
            id: item.id,
            purchaseId: purchaseData.purchaseId,
            purchaseRefId: id,
            HSN_code: item.HSN_code,
            branch_name: item.branch_name || "Default Branch",
            brand_name: item.brand_name,
            type: item.type,
            tyre_size: item.tyre_size,
            status: item.status,
            Category: item.Category,
            Subcategory: item.Subcategory,
            Quantity: newQuantity,
            purchase_quantity: newQuantity,
            purchase_rate: Number(item.rate) || 0,
            Gst: Number(item.gst) || 0,
            purchase_gst: Number(item.gst) || 0,
            Mrp: Number(item.Mrp) || 0,
          };
          let updatedItems;
          if (newQuantity === 0) {
            updatedItems = prevItems.filter((_, i) => i !== existingItemIndex);
          } else if (existingItemIndex >= 0) {
            updatedItems = [...prevItems];
            updatedItems[existingItemIndex] = newItem;
          } else {
            updatedItems = [...prevItems, newItem];
          }
          calculateTotals(updatedItems, paymentHistory);
          return updatedItems;
        });

        return newQuantities;
      });
    },
    [calculateTotals, purchaseData.purchaseId, paymentHistory, id]
  );

  const handlePurchaseDataChange = (e) => {
    const { name, value } = e.target;
    setPurchaseData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({
      ...prev,
      [name]: !value
        ? `${name === "dealerName"
          ? "Dealer Name"
          : name === "mobile_no"
            ? "Mobile Number"
            : name
        } is required`
        : name === "mobile_no" && !/^[0-9]{10}$/.test(value)
          ? "Mobile number must be a valid 10-digit number"
          : "",
    }));
  };

  const handlePurchaseItemChange = (e) => {
    const { name, value } = e.target;
    setPurchaseItemForm((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({
      ...prev,
      [name]: !value
        ? `${name === "brand_name" ? "Brand" : name} is required`
        : isNaN(value) || Number(value) <= (name === "Gst" || name === "purchase_gst" ? -1 : 0)
          ? `${name} must be a ${name === "Gst" || name === "purchase_gst" ? "non-negative" : "positive"} number`
          : "",
    }));
    if (name === "brand_name") {
      const selectedProduct = products.find(
        (product) => product.brand_name === value
      );
      setPurchaseItemForm((prev) => ({
        ...prev,
        branch_name: "Default Branch",
        brand_name: value,
        tyre_size: selectedProduct ? selectedProduct.tyre_size : "",
        type: selectedProduct ? selectedProduct.type : "",
        purchase_rate: selectedProduct ? selectedProduct.rate : "",
        Gst: selectedProduct ? selectedProduct.gst : "",
        HSN_code: selectedProduct ? selectedProduct.HSN_code : "",
        Category: selectedProduct ? selectedProduct.Category : "",
        Subcategory: selectedProduct ? selectedProduct.Subcategory : "",
        purchase_quantity: "",
        purchase_gst: selectedProduct ? selectedProduct.gst : "",
        Mrp: selectedProduct ? selectedProduct.Mrp : "",
      }));
      setFormErrors((prev) => ({
        ...prev,
        brand_name: !value ? "Brand is required" : "",
      }));
    }
  };

  const handleAddPurchaseItem = () => {
    if (!validatePurchaseItemForm()) {
      setShowAddRow(true);
      setError("Please fill all item fields correctly");
      return;
    }

    const newItem = {
      ...purchaseItemForm,
      id:
        editIndex !== null
          ? purchaseItems[editIndex].id
          : Date.now().toString(),
      purchaseId: purchaseData.purchaseId,
      purchaseRefId: id,
      Quantity: Number(purchaseItemForm.Quantity),
      purchase_quantity: Number(purchaseItemForm.purchase_quantity),
      purchase_rate: Number(purchaseItemForm.purchase_rate),
      Gst: Number(purchaseItemForm.Gst),
      purchase_gst: Number(purchaseItemForm.purchase_gst),
      Mrp: Number(purchaseItemForm.Mrp),
    };

    setPurchaseItems((prevItems) => {
      const updatedItems =
        editIndex !== null ? [...prevItems] : [...prevItems, newItem];
      if (editIndex !== null) updatedItems[editIndex] = newItem;
      calculateTotals(updatedItems, paymentHistory);
      return updatedItems;
    });

    setQuantities((prev) => ({
      ...prev,
      [newItem.id]: newItem.purchase_quantity,
    }));

    resetPurchaseItemForm();
    setShowAddRow(false);
    setEditIndex(null);
  };

  const resetPurchaseItemForm = () => {
    setPurchaseItemForm({
      HSN_code: "",
      branch_name: "Default Branch",
      brand_name: "",
      type: "",
      tyre_size: "",
      Quantity: "",
      purchase_rate: "",
      Gst: "",
      Category: "",
      Subcategory: "",
      status: "In Stock",
      purchase_quantity: "",
      purchase_gst: "",
      Mrp: "",
    });
    setFormErrors({
      brand_name: "",
      Quantity: "",
      purchase_rate: "",
      Gst: "",
      purchaseDate: "",
      purchase_quantity: "",
      purchase_gst: "",
      Mrp: "",
      dealerName: "",
      mobile_no: "",
    });
  };

  const handleEditPurchaseItemField = (index, field, value) => {
    const updatedItems = [...purchaseItems];
    updatedItems[index] = { ...updatedItems[index], [field]: value };

    const errors = {};
    if (field === "Quantity" || field === "purchase_quantity") {
      if (!value) errors[field] = "Quantity is required";
      else if (isNaN(value) || Number(value) <= 0)
        errors[field] = "Quantity must be a positive number";
    }
    if (field === "purchase_rate") {
      if (!value) errors.purchase_rate = "Purchase Rate is required";
      else if (isNaN(value) || Number(value) <= 0)
        errors.purchase_rate = "Purchase Rate must be a positive number";
    }
    if (field === "Gst" || field === "purchase_gst") {
      if (!value) errors[field] = "GST is required";
      else if (isNaN(value) || Number(value) < 0)
        errors[field] = "GST must be a non-negative number";
    }
    if (field === "Mrp") {
      if (!value) errors.Mrp = "MRP is required";
      else if (isNaN(value) || Number(value) <= 0)
        errors.Mrp = "MRP must be a positive number";
    }
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      setPurchaseItems(updatedItems);
      calculateTotals(updatedItems, paymentHistory);
      setQuantities((prev) => ({
        ...prev,
        [updatedItems[index].id]: Number(value),
      }));
    }
  };

  const handleEditItem = (index) => {
    setPurchaseItemForm({
      ...purchaseItems[index],
      Quantity: purchaseItems[index].purchase_quantity,
      purchase_rate: purchaseItems[index].purchase_rate,
      Gst: purchaseItems[index].purchase_gst,
    });
    setEditIndex(index);
    setShowAddRow(true);
    setFormErrors({
      brand_name: "",
      Quantity: "",
      purchase_rate: "",
      Gst: "",
      purchaseDate: "",
      purchase_quantity: "",
      purchase_gst: "",
      Mrp: "",
      dealerName: "",
      mobile_no: "",
    });
  };

  const handleDeleteItem = (index) => {
    const updatedItems = purchaseItems.filter((_, i) => i !== index);
    setPurchaseItems(updatedItems);
    calculateTotals(updatedItems, paymentHistory);
    setQuantities((prev) => ({
      ...prev,
      [purchaseItems[index].id]: 0,
    }));
  };

  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    setPaymentForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddPayment = () => {
    if (!paymentForm.pay_type || !paymentForm.amount) {
      setError("Please fill all payment fields");
      return;
    }

    if (isNaN(paymentForm.amount) || Number(paymentForm.amount) <= 0) {
      setError("Payment amount must be a positive number");
      return;
    }

    const newPayment = {
      ...paymentForm,
      id:
        paymentEditIndex !== null
          ? paymentHistory[paymentEditIndex].id
          : Date.now().toString(),
      amount: Number(paymentForm.amount),
    };

    setPaymentHistory((prev) => {
      const updatedHistory =
        paymentEditIndex !== null ? [...prev] : [...prev, newPayment];
      if (paymentEditIndex !== null)
        updatedHistory[paymentEditIndex] = newPayment;
      calculateTotals(purchaseItems, updatedHistory);
      return updatedHistory;
    });

    resetPaymentForm();
    setPaymentEditIndex(null);
    toast.success("Payment added successfully!");
  };

  const resetPaymentForm = () => {
    setPaymentForm({
      date: new Date().toISOString().split("T")[0],
      pay_type: "",
      amount: "",
    });
  };

  const handleEditPayment = (index) => {
    setPaymentForm(paymentHistory[index]);
    setPaymentEditIndex(index);
  };

  const handleDeletePayment = (index) => {
    const updatedPayments = paymentHistory.filter((_, i) => i !== index);
    setPaymentHistory(updatedPayments);
    calculateTotals(purchaseItems, updatedPayments);
    toast.success("Payment deleted successfully!");
  };

  const handleCancel = () => {
    navigate("/purchases");
  };

  const handleSubmit = async () => {
    const errors = {};
    if (!purchaseData.purchaseId) errors.purchaseId = "Purchase ID is required";
    if (!purchaseData.purchaseDate) errors.purchaseDate = "Purchase date is required";
    if (!purchaseData.dealerName) errors.dealerName = "Dealer name is required";
    if (!purchaseData.mobile_no) errors.mobile_no = "Mobile number is required";
    if (purchaseItems.length === 0)
      errors.purchaseItems = "At least one purchase item is required";

    if (Object.keys(errors).length > 0) {
      setError(Object.values(errors).join(", "));
      return;
    }

    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(purchaseData.mobile_no)) {
      setError("Mobile number must be a valid 10-digit number");
      setFormErrors((prev) => ({
        ...prev,
        mobile_no: "Mobile number must be a valid 10-digit number",
      }));
      return;
    }

    let formattedPurchaseDate;
    try {
      formattedPurchaseDate = new Date(purchaseData.purchaseDate)
        .toISOString()
        .split("T")[0];
      if (!formattedPurchaseDate || formattedPurchaseDate === "Invalid Date") {
        throw new Error("Invalid purchase date format");
      }
    } catch (error) {
      setError("Invalid purchase date format");
      setFormErrors((prev) => ({
        ...prev,
        purchaseDate: "Invalid purchase date format",
      }));
      return;
    }

    const payload = {
      id: id,
      purchaseId: purchaseData.purchaseId,
      purchaseDate: formattedPurchaseDate,
      mobile_no: purchaseData.mobile_no,
      dealerName: purchaseData.dealerName,
      subTotal: parseFloat(purchaseData.subTotal),
      gstAmount: parseFloat(purchaseData.gstAmount),
      netTotal: parseFloat(purchaseData.netTotal),
      paidAmount: parseFloat(purchaseData.paidAmount),
      balance: purchaseData.balance,
      purchaseItems: purchaseItems.map((item) => ({
        id: item.id,
        purchaseId: item.purchaseId,
        purchaseRefId: id,
        HSN_code: item.HSN_code,
        brand_name: item.brand_name,
        type: item.type,
        tyre_size: item.tyre_size,
        status: item.status,
        Category: item.Category,
        Subcategory: item.Subcategory,
        purchase_rate: Number(item.purchase_rate),
        purchase_gst: Number(item.purchase_gst),
        purchase_quantity: Number(item.purchase_quantity),
        Mrp: Number(item.Mrp),
      })),
      purchasePaymentHistory: paymentHistory.map((payment) => ({
        id: payment.id,
        purchaseId: purchaseData.purchaseId,
        date: payment.date,
        pay_type: payment.pay_type,
        amount: parseFloat(payment.amount),
      })),
    };

    try {
      setIsLoading(true);

      // Update purchase data
      const purchaseResponse = await axios.put(
        `${ApiUrl}/purchase_data.php/${id}`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        },
        navigate("/purchases")
      );

      if (!purchaseResponse.data.success) {
        setError(purchaseResponse.data.message || "Failed to update purchase");
        return;
      }

      // Process stock updates for each purchase item
      for (const item of purchaseItems) {
        const stockCheckPayload = {
          hsn_code: item.HSN_code,
          category: item.Category,
          subcategory: item.Subcategory,
        };

        const stockCheckResponse = await axios.get(
          `${BASE_URL}/stockdata.php`,
          {
            params: stockCheckPayload,
            headers: { "Content-Type": "application/json" },
          }
        );

        const stockExists = stockCheckResponse.data.status && stockCheckResponse.data.data?.length > 0;
        const existingStock = stockExists ? stockCheckResponse.data.data[0] : null;

        if (stockExists) {
          const updatedStockPayload = {
            id: existingStock.id,
            hsn_code: item.HSN_code,
            type: item.type,
            tyre_size: item.tyre_size,
            category: item.Category,
            subcategory: item.Subcategory,
            purchase_rate: parseFloat(item.purchase_rate) || 0,
            avg_purchase_rate:
              ((parseFloat(existingStock.avg_purchase_rate) * existingStock.total_purchase_quantity) +
                (parseFloat(item.purchase_rate) * Number(item.purchase_quantity))) /
              (existingStock.total_purchase_quantity + Number(item.purchase_quantity)),
            mrp: item.Mrp || existingStock.mrp || "0",
            available_quantity: existingStock.available_quantity + Number(item.purchase_quantity),
            total_purchase_quantity: existingStock.total_purchase_quantity + Number(item.purchase_quantity),
            sold_quantity: existingStock.sold_quantity || 0,
            total_purchases: existingStock.total_purchases + 1,
          };

          const stockUpdateResponse = await axios.put(
            `${BASE_URL}/stockdata.php/${existingStock.id}`,
            updatedStockPayload,
            {
              headers: { "Content-Type": "application/json" },
            }
          );

          if (!stockUpdateResponse.data.status) {
            throw new Error(
              `Failed to update stock for item ${item.HSN_code}: ${stockUpdateResponse.data.message}`
            );
          }
        } else {
          const stockPayload = {
            hsn_code: item.HSN_code,
            type: item.type,
            tyre_size: item.tyre_size,
            category: item.Category,
            subcategory: item.Subcategory,
            purchase_rate: parseFloat(item.purchase_rate) || 0,
            avg_purchase_rate: parseFloat(item.purchase_rate) || 0,
            mrp: item.Mrp || "0",
            available_quantity: Number(item.purchase_quantity) || 0,
            total_purchase_quantity: Number(item.purchase_quantity) || 0,
            sold_quantity: 0,
            total_purchases: 1,
          };

          const stockResponse = await axios.post(
            `${BASE_URL}/stockdata.php`,
            stockPayload,
            {
              headers: { "Content-Type": "application/json" },
            }
          );

          if (!stockResponse.data.status) {
            throw new Error(
              `Failed to create stock for item ${item.HSN_code}: ${stockResponse.data.message}`
            );
          }
        }
      }

      toast.success("Purchase updated successfully!");
      navigate("/purchases");
    } catch (error) {
      console.error("Error updating purchase or stock:", error);
      setError(
        error.response?.status === 404
          ? "Purchase or stock not found"
          : error.message || "Failed to update purchase or stock"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrint = () => {
    if (purchaseData.purchaseId) {
      navigate(`/purchase_bill/${id}`);
    } else {
      toast.error("Cannot print: Purchase ID is not available");
    }
  };

  const handleProductSubmit = async (e) => {
    e.preventDefault();
    if (
      !productData.Category ||
      !productData.Subcategory ||
      !productData.rate ||
      !productData.gst ||
      !productData.Mrp
    ) {
      setError("Please fill all required product fields");
      return;
    }

    if (
      isNaN(productData.rate) ||
      Number(productData.rate) <= 0 ||
      isNaN(productData.gst) ||
      Number(productData.gst) < 0 ||
      isNaN(productData.Mrp) ||
      Number(productData.Mrp) <= 0
    ) {
      setError("Rate, GST, and MRP must be valid numbers");
      return;
    }

    try {
      setIsLoading(true);
      const formData = {
        HSN_code: productData.HSN_code,
        Category: productData.Category,
        Subcategory: productData.Subcategory,
        branch_name: productData.branch_name,
        brand_name: productData.brand_name,
        type: productData.type,
        tyre_size: productData.tyre_size,
        rate: Number(productData.rate),
        gst: Number(productData.gst),
        status: productData.status,
        Mrp: Number(productData.Mrp),
      };
      await axios.post(`${ApiUrl}/product_data.php`, formData);
      const newProduct = { ...formData, id: Date.now().toString() };
      setProducts((prev) => [...prev, newProduct]);

      setCategoryTableData((prev) => {
        const updated = [...prev];
        const categoryIndex = updated.findIndex(
          (cat) => cat.Category === formData.Category
        );
        if (categoryIndex >= 0) {
          if (
            !updated[categoryIndex].SubCategories.includes(formData.Subcategory)
          ) {
            updated[categoryIndex].SubCategories.push(formData.Subcategory);
          }
        } else {
          updated.push({
            Category: formData.Category,
            SubCategories: [formData.Subcategory],
          });
        }
        return updated;
      });

      setQuantities((prev) => ({ ...prev, [newProduct.id]: 0 }));
      fetchNextProductId();
      setShowModal(false);
      setPurchaseItemForm((prev) => ({
        ...prev,
        HSN_code: formData.HSN_code,
        branch_name: formData.branch_name,
        brand_name: formData.brand_name,
        type: formData.type,
        tyre_size: formData.tyre_size,
        purchase_rate: formData.rate,
        Gst: formData.gst,
        Category: formData.Category,
        Subcategory: formData.Subcategory,
        purchase_quantity: "",
        purchase_gst: formData.gst,
        Mrp: formData.Mrp,
      }));
      setError(null);
    } catch (error) {
      console.error("Error adding product:", error);
      setError(error.response?.data?.message || "Failed to add product");
    } finally {
      setIsLoading(false);
    }
  };

  const filteredData = useMemo(() => {
    if (!searchQuery.trim()) return categoryTableData;
    const query = searchQuery.toLowerCase().trim();
    return categoryTableData.filter((category) => {
      const categoryMatches = category.Category.toLowerCase().includes(query);
      const subCategoryMatches = category.SubCategories.some((subCat) =>
        subCat.toLowerCase().includes(query)
      );
      const productMatches = products.some(
        (item) =>
          item.Category === category.Category &&
          (item.brand_name.toLowerCase().includes(query) ||
            item.type.toLowerCase().includes(query) ||
            item.tyre_size.toLowerCase().includes(query) ||
            item.Subcategory.toLowerCase().includes(query))
      );
      return categoryMatches || subCategoryMatches || productMatches;
    });
  }, [categoryTableData, products, searchQuery]);

  const getFilteredProducts = (categoryName) => {
    const query = searchQuery.toLowerCase().trim();
    return products.filter(
      (item) =>
        item.Category === categoryName &&
        (!query ||
          item.brand_name.toLowerCase().includes(query) ||
          item.type.toLowerCase().includes(query) ||
          item.tyre_size.toLowerCase().includes(query) ||
          item.Subcategory.toLowerCase().includes(query))
    );
  };

  useEffect(() => {
    if (searchQuery.trim()) {
      setExpandedCategories(
        filteredData.reduce(
          (acc, cat) => ({ ...acc, [cat.Category]: true }),
          {}
        )
      );
    }
  }, [searchQuery, filteredData]);

  const clearSearch = () => setSearchQuery("");

  return (
    <div className="bg-white font-sans overflow-x-hidden">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
      {error && (
        <div className="alert alert-danger mx-4" role="alert">
          {error}
        </div>
      )}
      {isLoading && <div className="text-center">Loading...</div>}
      <h2 className="m-0 fs-5 fw-semibold text-dark mx-4 mb-3">
        Update Purchase
      </h2>
      <div className="row g-3">
        <div className="col-lg-3">
          <div className="card p-2 h-100">
            <div className="mb-4 d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Product List</h5>
              <button
                className="btn btn-primary"
                onClick={() => {
                  setShowModal(true);
                  fetchNextProductId();
                }}
              >
                <Plus size={16} />
              </button>
            </div>
            <div className="mb-3">
              <label htmlFor="searchInput" className="form-label">
                Search Products
              </label>
              <div className="input-group">
                <input
                  type="text"
                  id="searchInput"
                  className="form-control"
                  placeholder="Search by category, brand, type, size..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                {searchQuery && (
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={clearSearch}
                  >
                    ×
                  </button>
                )}
              </div>
              {searchQuery && (
                <small className="text-muted">
                  Showing {filteredData.length} categories
                </small>
              )}
            </div>
            <div className="table-responsive">
              <table
                className="table table-bordered table-sm"
                style={{ fontSize: "13px" }}
              >
                <thead>
                  <tr>
                    <th></th>
                    <th>Products</th>
                    <th>Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((category) => (
                    <React.Fragment key={category.Category}>
                      <tr>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => toggleCategory(category.Category)}
                          >
                            {expandedCategories[category.Category] ? (
                              <ChevronUp size={16} />
                            ) : (
                              <ChevronDown size={16} />
                            )}
                          </button>
                        </td>
                        <td colSpan="4" className="fw-bold">
                          {category.Category}
                        </td>
                      </tr>
                      {expandedCategories[category.Category] &&
                        getFilteredProducts(category.Category).map((item) => (
                          <tr key={item.id}>
                            <td></td>
                            <td>
                              {item.brand_name} - {item.type || "N/A"} -{" "}
                              {item.tyre_size || "N/A"}
                            </td>
                            <td>
                              <div className="d-flex align-items-center">
                                <button
                                  className="btn btn-sm btn-outline-secondary me-2"
                                  onClick={() =>
                                    handleQuantityChange(item, "decrease")
                                  }
                                  disabled={quantities[item.id] === 0}
                                >
                                  -
                                </button>
                                <span>{quantities[item.id]}</span>
                                <button
                                  className="btn btn-sm btn-outline-secondary ms-2"
                                  onClick={() =>
                                    handleQuantityChange(item, "increase")
                                  }
                                >
                                  +
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="card border h-100">
            <div className="card-body p-0">
              <h5 className="p-2">Purchase Items List</h5>
              <div className="table-responsive">
                <table className="table table-sm table-hover mb-0 text-center">
                  <thead>
                    <tr style={{ backgroundColor: "#d3d3d3" }}>
                      <th className="p-3 text-start  text-white fw-semibold small border-bottom bg-danger">
                        S.No
                      </th>
                      <th className="p-3 text-center text-white fw-semibold small border-bottom bg-danger">
                        Products
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        Pur Rate
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        GST(%)
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        Qty
                      </th>
                      <th className="p-3 text-start  text-white fw-semibold small border-bottom bg-danger">
                        MRP
                      </th>
                      <th className="p-3 text-start text-white fw-semibold small border-bottom bg-danger">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {purchaseItems.length > 0 ? (
                      purchaseItems.map((item, index) => (
                        <React.Fragment key={item.id}>
                          <tr style={{ fontSize: "14px", fontWeight: "400" }}>
                            <td>{index + 1}</td>
                            <td>{item.brand_name}</td>
                            <td>
                              <input
                                type="number"
                                className={`form-control form-control-sm ${formErrors.purchase_rate && index === editIndex
                                    ? "border-danger"
                                    : ""
                                  }`}
                                value={item.purchase_rate}
                                onChange={(e) =>
                                  handleEditPurchaseItemField(
                                    index,
                                    "purchase_rate",
                                    e.target.value
                                  )
                                }
                                style={{ width: "100px" }}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className={`form-control form-control-sm ${formErrors.purchase_gst && index === editIndex
                                    ? "border-danger"
                                    : ""
                                  }`}
                                value={item.purchase_gst}
                                onChange={(e) =>
                                  handleEditPurchaseItemField(
                                    index,
                                    "purchase_gst",
                                    e.target.value
                                  )
                                }
                                style={{ width: "50px" }}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className={`form-control form-control-sm ${formErrors.purchase_quantity && index === editIndex
                                    ? "border-danger"
                                    : ""
                                  }`}
                                value={item.purchase_quantity}
                                onChange={(e) =>
                                  handleEditPurchaseItemField(
                                    index,
                                    "purchase_quantity",
                                    e.target.value
                                  )
                                }
                                style={{ width: "50px" }}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className={`form-control form-control-sm ${formErrors.Mrp && index === editIndex
                                    ? "border-danger"
                                    : ""
                                  }`}
                                value={item.Mrp}
                                onChange={(e) =>
                                  handleEditPurchaseItemField(
                                    index,
                                    "Mrp",
                                    e.target.value
                                  )
                                }
                                style={{ width: "100px" }}
                              />
                            </td>
                            <td>
                              <div className="d-flex gap-2">
                                {/* <button
                                  onClick={() => handleEditItem(index)}
                                  className="border-0 bg-transparent text-muted"
                                >
                                  <Edit2 size={16} />
                                </button> */}
                                <button
                                  onClick={() => handleDeleteItem(index)}
                                  className="border-0 bg-transparent text-muted"
                                >
                                  <Trash2 size={16} />
                                </button>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="8">
                              <div className="card p-2 bg-light border rounded mb-2">
                                <div className="row">
                                  <div className="col-md-6">
                                    <strong>Tyre Size:</strong>{" "}
                                    {item.tyre_size || "N/A"} | <strong>MRP:</strong>{" "}
                                    {item.Mrp || "N/A"}
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No purchase items added
                        </td>
                      </tr>
                    )}
                    {showAddRow && (
                      <tr>
                        <td>{purchaseItems.length + 1}</td>
                        <td>
                          <select
                            className={`form-select form-select-sm ${formErrors.brand_name ? "border-danger" : ""
                              }`}
                            name="brand_name"
                            value={purchaseItemForm.brand_name}
                            onChange={handlePurchaseItemChange}
                            style={{ width: "100px" }}
                          >
                            <option value="">Select Brand</option>
                            {products
                              .filter(
                                (p, i, arr) =>
                                  arr.findIndex(
                                    (x) => x.brand_name === p.brand_name
                                  ) === i
                              )
                              .map((product) => (
                                <option
                                  key={product.id}
                                  value={product.brand_name}
                                >
                                  {product.brand_name}
                                </option>
                              ))}
                          </select>
                        </td>
                        <td>
                          <input
                            type="number"
                            className={`form-control form-control-sm ${formErrors.purchase_rate ? "border-danger" : ""
                              }`}
                            name="purchase_rate"
                            value={purchaseItemForm.purchase_rate}
                            onChange={handlePurchaseItemChange}
                            style={{ width: "100px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            className={`form-control form-control-sm ${formErrors.purchase_gst ? "border-danger" : ""
                              }`}
                            name="purchase_gst"
                            value={purchaseItemForm.purchase_gst}
                            onChange={handlePurchaseItemChange}
                            style={{ width: "80px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            className={`form-control form-control-sm ${formErrors.purchase_quantity ? "border-danger" : ""
                              }`}
                            name="purchase_quantity"
                            value={purchaseItemForm.purchase_quantity}
                            onChange={handlePurchaseItemChange}
                            style={{ width: "80px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            className={`form-control form-control-sm ${formErrors.Mrp ? "border-danger" : ""
                              }`}
                            name="Mrp"
                            value={purchaseItemForm.Mrp}
                            onChange={handlePurchaseItemChange}
                            style={{ width: "100px" }}
                          />
                        </td>
                        <td>
                          <button
                            className="btn btn-sm btn-success"
                            onClick={handleAddPurchaseItem}
                          >
                            {editIndex !== null ? "Update" : "Add"}
                          </button>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-3">
          <div className="card h-100" style={{ backgroundColor: "#fff0f5" }}>
            <div className="p-3">
              <div className="row mb-2">
                <div className="col-md-5">
                  <label className="form-label small fw-medium" style={{ fontSize: "14px" }}>
                    Purchase No
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="purchaseId"
                    value={purchaseData.purchaseId}
                    readOnly
                    style={{ padding: "10px", fontSize: "14px", background: "white" }}
                  />
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-5">
                  <label className="form-label small fw-medium" style={{ fontSize: "14px" }}>
                    Date <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    type="date"
                    className={`form-control form-control-sm ${formErrors.purchaseDate ? "border-danger" : ""
                      }`}
                    name="purchaseDate"
                    value={purchaseData.purchaseDate}
                    onChange={handlePurchaseDataChange}
                    style={{ padding: "10px", fontSize: "14px", background: "white" }}
                    required
                  />
                  {formErrors.purchaseDate && (
                    <div className="text-danger small">{formErrors.purchaseDate}</div>
                  )}
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-5">
                  <label className="form-label small fw-medium" style={{ fontSize: "14px" }}>
                    Dealer Name <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    type="text"
                    className={`form-control form-control-sm ${formErrors.dealerName ? "border-danger" : ""
                      }`}
                    name="dealerName"
                    value={purchaseData.dealerName}
                    onChange={handlePurchaseDataChange}
                    style={{ padding: "10px", fontSize: "14px", background: "white" }}
                    required
                  />
                  {formErrors.dealerName && (
                    <div className="text-danger small">{formErrors.dealerName}</div>
                  )}
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-5">
                  <label className="form-label small fw-medium" style={{ fontSize: "14px" }}>
                    Mobile No <span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    type="tel"
                    className={`form-control form-control-sm ${formErrors.mobile_no ? "border-danger" : ""
                      }`}
                    name="mobile_no"
                    value={purchaseData.mobile_no}
                    onChange={handlePurchaseDataChange}
                    style={{ padding: "10px", fontSize: "14px", background: "white" }}
                    required
                  />
                  {formErrors.mobile_no && (
                    <div className="text-danger small">{formErrors.mobile_no}</div>
                  )}
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-5">
                  <label className="form-label small fw-semibold text-muted" style={{ fontSize: "14px" }}>
                    Sub Total
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    className="form-control form-control-sm bg-light"
                    value={purchaseData.subTotal}
                    disabled
                    style={{ padding: "8px", fontSize: "14px" }}
                  />
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-5">
                  <label className="form-label small fw-semibold text-muted" style={{ fontSize: "14px" }}>
                    GST Amount
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    className="form-control form-control-sm bg-light"
                    value={purchaseData.gstAmount}
                    disabled
                    style={{ padding: "8px", fontSize: "14px" }}
                  />
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-5">
                  <label className="form-label small fw-semibold text-muted" style={{ fontSize: "14px" }}>
                    Net Total
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    className="form-control form-control-sm bg-light"
                    value={purchaseData.netTotal}
                    disabled
                    style={{ padding: "8px", fontSize: "14px" }}
                  />
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-5">
                  <label className="form-label small fw-semibold text-muted" style={{ fontSize: "14px" }}>
                    Paid Amount
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    className="form-control form-control-sm bg-light"
                    value={purchaseData.paidAmount}
                    disabled
                    style={{ padding: "8px", fontSize: "14px" }}
                  />
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-5">
                  <label className="form-label small fw-semibold text-muted" style={{ fontSize: "14px" }}>
                    Balance
                  </label>
                </div>
                <div className="col-md-7">
                  <input
                    className="form-control form-control-sm bg-light"
                    value={purchaseData.balance}
                    disabled
                    style={{ padding: "8px", fontSize: "14px" }}
                  />
                </div>
              </div>

              <div className="d-flex flex-column flex-md-row gap-1 mt-3">
                <button
                  className="btn btn-success btn-sm"
                  onClick={() => setShowPaymentModal(true)}
                >
                  Add Payment
                </button>
                <button
                  className="btn btn-success btn-sm"
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  Update
                </button>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={handlePrint}
                >
                  Print
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{
          display: showModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content rounded"
            style={{ backgroundColor: "#fff0f5" }}
          >
            <div className="modal-header bg-pink-light border-bottom-0">
              <h5 className="modal-title m-0 fw-semibold">Add Product</h5>
              <button
                className="btn-close"
                onClick={() => setShowModal(false)}
                disabled={isLoading}
              ></button>
            </div>
            <div className="modal-body bg-light">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    HSN Code <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={productData.HSN_code}
                    readOnly
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Category <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.Category}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        Category: e.target.value,
                        Subcategory: "",
                      })
                    }
                    required
                  >
                    <option value="">Select Category</option>
                    {categoryTableData.map((category) => (
                      <option key={category.Category} value={category.Category}>
                        {category.Category}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Subcategory <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.Subcategory}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        Subcategory: e.target.value,
                      })
                    }
                    disabled={!productData.Category}
                    required
                  >
                    <option value="">Select Subcategory</option>
                    {productData.Category &&
                      categoryTableData
                        .find((cat) => cat.Category === productData.Category)
                        ?.SubCategories.map((subcat) => (
                          <option key={subcat} value={subcat}>
                            {subcat}
                          </option>
                        ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Branch Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={productData.branch_name}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        branch_name: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Brand Name
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.brand_name}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        brand_name: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Brand Name</option>
                    <option value="MRF">MRF</option>
                    <option value="CEAT">CEAT</option>
                    <option value="Apollo">Apollo</option>
                    <option value="JK Tyre">JK Tyre</option>
                    <option value="Bridgestone">Bridgestone</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Type
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.type}
                    onChange={(e) =>
                      setProductData({ ...productData, type: e.target.value })
                    }
                  >
                    <option value="">Select Type</option>
                    <option value="Radial">Radial</option>
                    <option value="Bias">Bias</option>
                    <option value="Tubeless">Tubeless</option>
                    <option value="Tube Type">Tube Type</option>
                    <option value="Solid">Solid</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Tyre Size
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={productData.tyre_size}
                    onChange={(e) =>
                      setProductData({
                        ...productData,
                        tyre_size: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Rate <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    value={productData.rate}
                    onChange={(e) =>
                      setProductData({ ...productData, rate: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    GST <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    value={productData.gst}
                    onChange={(e) =>
                      setProductData({ ...productData, gst: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    MRP <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    value={productData.Mrp}
                    onChange={(e) =>
                      setProductData({ ...productData, Mrp: e.target.value })
                    }
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label small fw-medium">
                    Product Status
                  </label>
                  <select
                    className="form-select form-select-sm"
                    value={productData.status}
                    onChange={(e) =>
                      setProductData({ ...productData, status: e.target.value })
                    }
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="modal-footer border-top-0">
              <button
                className="btn btn-sm btn-danger"
                onClick={() => setShowModal(false)}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                className="btn btn-sm btn-success"
                onClick={handleProductSubmit}
                disabled={isLoading}
              >
                {isLoading ? "Adding..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${showPaymentModal ? "show" : ""}`}
        style={{
          display: showPaymentModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content" style={{ backgroundColor: "#fff0f5" }}>
            <div className="modal-header bg-pink-light border-bottom-0">
              <h5 className="modal-title m-0 fw-semibold">Add Payment</h5>
              <button
                className="btn-close"
                onClick={() => {
                  setShowPaymentModal(false);
                  resetPaymentForm();
                }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-2">
                <div className="col-md-5">
                  <label className="form-label fw-medium small">
                    Balance
                    <input
                      className="form-control form-control-sm mt-1 text-success"
                      value={purchaseData.balance}
                      disabled
                    />
                  </label>
                </div>
                <div className="col-md-5">
                  <label className="form-label fw-medium small">
                    Paid
                    <input
                      className="form-control form-control-sm mt-1 text-success"
                      value={purchaseData.paidAmount}
                      disabled
                    />
                  </label>
                </div>
              </div>
              <div className="row g-2 mt-2">
                <div className="col-md-5">
                  <select
                    className="form-select form-select-sm"
                    name="pay_type"
                    value={paymentForm.pay_type}
                    onChange={handlePaymentChange}
                  >
                    <option value="">Select Pay Type</option>
                    <option value="Cash">Cash</option>
                    <option value="Gpay">Gpay</option>
                    <option value="Phonepay">Phonepay</option>
                    <option value="Paytm">Paytm</option>
                    <option value="Credit">Credit</option>
                    <option value="Debit">Debit</option>
                  </select>
                </div>
                <div className="col-md-4">
                  <input
                    className="form-control form-control-sm"
                    name="amount"
                    type="number"
                    value={paymentForm.amount}
                    onChange={handlePaymentChange}
                    placeholder="Enter Amount"
                  />
                </div>
                <div className="col-md-2">
                  <button
                    className="btn btn-success btn-sm"
                    onClick={handleAddPayment}
                  >
                    {paymentEditIndex !== null ? "Update" : "Add"}
                  </button>
                </div>
              </div>
              <div className="mt-3">
                <table className="table table-bordered text-center">
                  <thead className="small fw-light">
                    <tr>
                      <th>S.No</th>
                      <th>Pay Type</th>
                      <th>Amount</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentHistory.map((payment, index) => (
                      <tr key={payment.id}>
                        <td>{index + 1}</td>
                        <td>{payment.pay_type}</td>
                        <td>{payment.amount}</td>
                        <td>
                          <div className="d-flex gap-2 justify-content-center">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() => handleEditPayment(index)}
                            >
                              <Edit2 size={16} />
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDeletePayment(index)}
                            >
                              <Trash2 size={16} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer border-top-0">
              <button
                className="btn btn-sm btn-success"
                onClick={() => {
                  setShowPaymentModal(false);
                  resetPaymentForm();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Purchase_update;